import { log } from '.';
import { withAPIAccount } from '../../../lib/http/api';
import { parsedResponse } from '../../../lib/http/http';
import { AccountType } from '../../../model';
import { IString } from '../../table';
import {
  FieldOptAPIReqScenes,
  FieldOptSource,
  IFieldOptAPI,
  IFieldOptAPIReqNormal,
  IFieldOptAPIReqProxy,
  IFieldOptAPIReqProxyAll,
} from '../model/field-model-extension-api';

function getLocalProjectID(): any | null {
  const win: any = window;
  const PROJECT_CENTER_ID = 'projectID';
  return win[PROJECT_CENTER_ID];
}

const formatReqBody = (
  optReq:
    | IFieldOptAPIReqNormal
    | IFieldOptAPIReqProxy
    | IFieldOptAPIReqProxyAll,
  fieldOpt: IFieldOptAPI,
  body?: Object,
  cacheFilterValues?: IString<any>
) => {
  if (body && optReq.formatReqData) {
    const mergeBody = {
      ...body,
      ...cacheFilterValues,
    };
    return optReq.formatReqData(mergeBody, optReq.kind, fieldOpt);
  }
  return body;
};

const getRemoteOptNormal = (
  optReq: IFieldOptAPIReqNormal,
  fieldOpt: IFieldOptAPI,
  cacheFilterValues?: IString<any>
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    const method = optReq.method || 'GET';
    try {
      const response: Response = await api.commonRequest(
        method,
        optReq.path,
        formatReqBody(optReq, fieldOpt, optReq.body, cacheFilterValues),
        optReq.customHeaders,
        optReq.timeout
      );
      return await parsedResponse(response);
    } catch (error) {
      log.error(error);
      return null;
    }
  });

const getRemoteOptByProxy = (
  optReq: IFieldOptAPIReqProxy,
  fieldOpt: IFieldOptAPI,
  cacheFilterValues?: IString<any>
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    const projectID = getLocalProjectID();
    const { platformID } = optReq;
    if (!optReq.transparentReqBody || !projectID || platformID === undefined) {
      log.error(
        `getRemoteOptByProxy api params error, projectID: ${projectID}, platformID: ${platformID}`
      );
      return null;
    }
    try {
      const response: Response = await api.proxyRequest(
        projectID,
        platformID,
        formatReqBody(
          optReq,
          fieldOpt,
          optReq.transparentReqBody,
          cacheFilterValues
        ),
        optReq.customHeaders,
        optReq.timeout
      );
      return await parsedResponse(response);
    } catch (error) {
      log.error(error);
      return null;
    }
  });

const getRemoteOptByProxyAll = (
  optReq: IFieldOptAPIReqProxyAll,
  fieldOpt: IFieldOptAPI,
  cacheFilterValues?: IString<any>
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    const projectID = getLocalProjectID();
    const { platformID } = optReq;
    if (!optReq.transparentReqBody || !projectID || platformID === undefined) {
      log.error(
        `getRemoteOptByProxy api params error, projectID: ${projectID}, platformID: ${platformID}`
      );
      return null;
    }
    try {
      const response = await api.proxyFetchAll(
        projectID,
        platformID,
        formatReqBody(
          optReq,
          fieldOpt,
          optReq.transparentReqBody,
          cacheFilterValues
        ),
        optReq.reqType,
        optReq.options
      );
      return response;
    } catch (error) {
      log.error(error);
      return null;
    }
  });

// 请求适配器
export const adapterXHR = async (
  fieldOpt: IFieldOptAPI,
  cacheFilterValues?: IString<any>
) => {
  if (fieldOpt.kind === FieldOptSource.api) {
    switch (fieldOpt.api.kind) {
      case FieldOptAPIReqScenes.normal:
        return await getRemoteOptNormal(
          fieldOpt.api,
          fieldOpt,
          cacheFilterValues
        );
      case FieldOptAPIReqScenes.proxy:
        return await getRemoteOptByProxy(
          fieldOpt.api,
          fieldOpt,
          cacheFilterValues
        );
      case FieldOptAPIReqScenes.proxyAll:
        return await getRemoteOptByProxyAll(
          fieldOpt.api,
          fieldOpt,
          cacheFilterValues
        );
      default:
        log.error('No XHR type adapter. Kind: [null]');
        return null;
    }
  }
  return null;
};
